// extracted by mini-css-extract-plugin
export default {"nav":"VsIh3r_DJXhPxnx8ui2A","navLinks":"ubBnxZ41JLqjzYP3Pcbl","navLink":"NgE9J2cyMLYpqSRsxr8E","navLinkActive":"jNHnEMtXT5R7TyEk4sA7"};